import template from './document-group-modal.pug';

export const DocumentGroupModalComponent = {
  template,
  bindings:{
    resolve: '<',
    modalInstance: '<',
  },
  controller: class DocumentGroupModalComponent {
    constructor($async, $log, Document, AlertBox) {
      'ngInject';
      this.Document = Document;
      this.AlertBox = AlertBox;
      this.$log = $log;
      this.save = $async(this.save.bind(this));
    }

    $onInit() {
      this.group = this.resolve.group || {};
    }


    async save({ group }) {
      try {
        if (group.id) {
          const resp =  await this.Document.updateGroup(group);
          this.modalInstance.close(resp);
          this.AlertBox.addMessage('alert.updated', { type: 'success' });
        } else {
          const resp =  await this.Document.createGroup(group);
          this.modalInstance.close(resp);
        }
      } catch (e) {
        this.$log.error(e);
      }
    }

    close() {
      this.modalInstance.close(void(0));
    }

  }
};
